module.exports = __webpack_public_path__ + "static/media/evsc.2a02d5c5.svg";